/* global
 Box2D
 */
import { tbGame } from "../tbGame";
import { tbVector } from "../tbVector";
import "./box2d";
export var Box2D = window.Box2D;
export var tbPhysics2 = function (scale, timeStep, maxSteps, gravity, depth, stepCallback) {
    "use strict";
    this.visible = false;
    this.active = true;
    this.scale = scale === undefined ? 0.01 : scale;
    gravity = gravity === undefined ? 750 : gravity;
    this.depth = depth || 0;
    this._initPhysicsEngine(gravity);
    this.stepEachFrame = true;
    this.fixedDeltaTime = timeStep;
    this.maxStepsPerFrame = maxSteps;
    this.timeAvailable = 0;
    this.maxVelocityIterations = 5;
    this.maxPositionIterations = 2;
    this.stepCount = 0;
    this.stepping = false;
    this.bodiesMarkedForDeletion = [];
    this.stepCallback = stepCallback;
    tbGame.addToken(this);
};
tbPhysics2.prototype._initPhysicsEngine = function (gravity) {
    "use strict";
    this.gravityVector = new tbVector(0, gravity * this.scale);
    var gravity = new Box2D.b2Vec2(0.0, gravity * this.scale);
    this.world = new Box2D.b2World(gravity, true);
    this.world.SetAllowSleeping(true);
    Box2D.destroy(gravity);
    // temporary pre-allocated objects
    this.temp = {};
    this.temp.vec0 = new Box2D.b2Vec2(0, 0);
    this.temp.vec1 = new Box2D.b2Vec2(0, 0);
    this.temp.vec2 = new Box2D.b2Vec2(0, 0);
    this.temp.vec3 = new Box2D.b2Vec2(0, 0);
    this.temp.vec4 = new Box2D.b2Vec2(0, 0);
    this.temp.vec5 = new Box2D.b2Vec2(0, 0);
    // Create some general shapes
    this.circleShape = new Box2D.b2CircleShape();
    this.polygonShape = new Box2D.b2PolygonShape();
    this._initRaycastCallback();
};
tbPhysics2.prototype._initRaycastCallback = function () {
    "use strict";
    this.raycastCallBack = new Box2D.JSRayCastCallback();
    this.raycastCallBack["ReportFixture"] = function (pFixture, pPoint, pNormal, fraction) {
        var self = this;
        var fixture = Box2D.wrapPointer(pFixture, Box2D.b2Fixture);
        var body = fixture.GetBody();
        if (body === self.body0 || body === self.body1) {
            return -1;
        }
        else {
            self.foundObjectBetween = true;
            return 0;
        }
    };
};
tbPhysics2.prototype.isSpaceBetween = function (body0, body1, rayWidth) {
    "use strict";
    this.raycastCallBack.body0 = body0;
    this.raycastCallBack.body1 = body1;
    var pos0 = body0.GetPosition();
    var pos1 = body1.GetPosition();
    var line = this.temp.vec0;
    line.Set(pos0.get_x() - pos1.get_x(), pos0.get_y() - pos1.get_y());
    var perp = this.temp.vec1;
    perp.Set(line.get_y(), -line.get_x());
    perp.Normalize();
    var perpX = perp.get_x() * rayWidth / 2 * this.scale;
    var perpY = perp.get_y() * rayWidth / 2 * this.scale;
    var cur_pos0 = this.temp.vec2;
    var cur_pos1 = this.temp.vec3;
    cur_pos0.Set(pos0.get_x() - perpX, pos0.get_y() - perpY);
    cur_pos1.Set(pos1.get_x() - perpX, pos1.get_y() - perpY);
    for (var i = -1; i <= 1; ++i) {
        this.raycastCallBack.foundObjectBetween = false;
        this.world.RayCast(this.raycastCallBack, cur_pos0, cur_pos1);
        if (this.raycastCallBack.foundObjectBetween) {
            return false;
        }
        cur_pos0.Set(cur_pos0.get_x() + perpX, cur_pos0.get_y() + perpY);
        cur_pos1.Set(cur_pos1.get_x() + perpX, cur_pos1.get_y() + perpY);
    }
    return true;
};
tbPhysics2.prototype.createBoundaries = function (x, y, width, height) {
    "use strict";
    var thickness = 10;
    var xBottom = x + width / 2;
    var yBottom = y + height + thickness / 2;
    var wallBottom = this.createBox(xBottom, yBottom, width, thickness, undefined, undefined, undefined, Box2D.b2_staticBody, 0);
    var xTop = x + width / 2;
    var yTop = y - thickness / 2;
    var wallTop = this.createBox(xTop, yTop, width, thickness, undefined, undefined, undefined, Box2D.b2_staticBody, 0);
    var xLeft = x - thickness / 2;
    var yLeft = y + height / 2;
    var wallLeft = this.createBox(xLeft, yLeft, thickness, height, undefined, undefined, undefined, Box2D.b2_staticBody, 0);
    var xRight = x + width + thickness / 2;
    var yRight = y + height / 2;
    var wallRight = this.createBox(xRight, yRight, thickness, height, undefined, undefined, undefined, Box2D.b2_staticBody, 0);
};
tbPhysics2.prototype.createBody = function (x, y, angle, shape, type, density, restitution, friction) {
    "use strict";
    var bd = new Box2D.b2BodyDef();
    bd.set_type(type);
    bd.set_position(this.ZERO);
    var body = this.world.CreateBody(bd);
    Box2D.destroy(bd);
    var fixture = new Box2D.b2FixtureDef();
    fixture.set_shape(shape);
    if (density !== undefined) {
        fixture.set_density(density);
    }
    else {
        fixture.set_density(5);
    }
    if (restitution !== undefined) {
        fixture.set_restitution(restitution);
    }
    if (friction !== undefined) {
        fixture.set_friction(friction);
    }
    body.CreateFixture(fixture);
    Box2D.destroy(fixture);
    this.temp.vec0.Set(x * this.scale, y * this.scale);
    body.SetTransform(this.temp.vec0, angle);
    body.SetSleepingAllowed(1);
    body.SetAwake(1);
    body.SetActive(1);
    return body;
};
tbPhysics2.prototype.createCircle = function (x, y, radius, density, restitution, friction, type, angle) {
    "use strict";
    this.circleShape.set_m_radius(radius * this.scale);
    if (type === undefined) {
        type = Box2D.b2_dynamicBody;
    }
    if (angle === undefined) {
        angle = Math.random() * Math.PI * 2;
    }
    var body = this.createBody(x, y, angle, this.circleShape, type, density, restitution, friction);
    return body;
};
tbPhysics2.prototype.createBox = function (x, y, width, height, density, restitution, friction, type, angle) {
    "use strict";
    this.polygonShape.SetAsBox(width / 2 * this.scale, height / 2 * this.scale);
    if (type === undefined) {
        type = Box2D.b2_dynamicBody;
    }
    if (angle === undefined) {
        angle = 0;
    }
    var body = this.createBody(x, y, angle, this.polygonShape, type, density, restitution, friction);
    return body;
};
tbPhysics2.prototype.getBodyData = function (body, data) {
    "use strict";
    if (!data) {
        data = new tbVector();
    }
    var bpos = body.GetPosition();
    data.x = bpos.get_x() / this.scale;
    data.y = bpos.get_y() / this.scale;
    data.angle = body.GetAngle();
    var v = body.GetLinearVelocity();
    if (!data.velocity) {
        data.velocity = new tbVector(0, 0);
    }
    data.velocity.x = v.get_x() / this.scale;
    data.velocity.y = v.get_y() / this.scale;
    data.angular_velocity = body.GetAngularVelocity();
    return data;
};
tbPhysics2.prototype.getX = function (body) {
    return body.GetPosition().get_x() / this.scale;
};
tbPhysics2.prototype.getY = function (body) {
    return body.GetPosition().get_y() / this.scale;
};
tbPhysics2.prototype.getAngle = function (body) {
    return body.GetAngle();
};
tbPhysics2.prototype.getVelocityX = function (body) {
    return body.GetLinearVelocity().get_x() / this.scale;
};
tbPhysics2.prototype.getVelocityY = function (body) {
    return body.GetLinearVelocity().get_y() / this.scale;
};
tbPhysics2.prototype.getVelocityAngle = function (body) {
    return body.GetAngularVelocity();
};
tbPhysics2.prototype.setPosition = function (body, x, y, angle) {
    "use strict";
    this.temp.vec0.Set(x * this.scale, y * this.scale);
    var a = angle || body.GetAngle();
    body.SetTransform(this.temp.vec0, a);
};
tbPhysics2.prototype.setAngle = function (body, angle) {
    this.temp.vec0.Set(body.get_x(), body.get_y());
    body.SetTransform(this.temp.vec0, angle);
};
tbPhysics2.prototype.setVelocity = function (body, x, y) {
    "use strict";
    this.temp.vec0.Set(x * this.scale, y * this.scale);
    body.SetLinearVelocity(this.temp.vec0);
};
tbPhysics2.prototype.setAngularVelocity = function (body, omega) {
    "use strict";
    body.SetAngularVelocity(omega);
};
tbPhysics2.prototype.applyForce = function (body, direction, power) {
    "use strict";
    power = typeof power === undefined ? 1 : power;
    var blastDir = this.temp.vec0;
    blastDir.Set(direction.x * power * this.scale, direction.y * power * this.scale);
    body.ApplyForceToCenter(blastDir);
};
tbPhysics2.prototype.applyLinearImpulse = function (body, direction, power) {
    "use strict";
    power = typeof power === undefined ? 1 : power;
    var m = Math.pow(this.scale, 3);
    var blastDir = this.temp.vec0;
    blastDir.Set(direction.x * power * m, direction.y * power * m);
    body.ApplyLinearImpulse(blastDir, body.GetPosition());
};
tbPhysics2.prototype.applyAngularImpulse = function (body, power) {
    "use strict";
    body.ApplyAngularImpulse(power * this.scale, true);
};
tbPhysics2.prototype.applyTorque = function (body, power) {
    "use strict";
    body.ApplyTorque(power * this.scale, true);
};
tbPhysics2.prototype.applyBlastImpulse = function (body, blastCenter, blastPower) {
    "use strict";
    var blastDir = this.temp.vec0;
    blastDir.Set(body.GetPosition().get_x() - blastCenter.x * this.scale, body.GetPosition().get_y() - blastCenter.y * this.scale);
    var distance = blastDir.Normalize();
    if (distance === 0) {
        return;
    }
    var invDistance = 1.0 / distance;
    var impulseMag = blastPower * invDistance * invDistance;
    blastDir.Set(blastDir.get_x() * impulseMag, blastDir.get_y() * impulseMag);
    body.ApplyLinearImpulse(blastDir, body.GetPosition());
};
tbPhysics2.prototype.handleRemove = function () {
    "use strict";
    var i;
    for (i = 0; i < this.temp.length; ++i) {
        Box2D.destroy(this.temp[i]);
    }
    Box2D.destroy(this.circleShape);
    Box2D.destroy(this.polygonShape);
    Box2D.destroy(this.world);
};
tbPhysics2.prototype.handleBeginStep = function (timePassed) {
    "use strict";
    this.timeAvailable += (timePassed / 1000);
    var count = 0;
    while (this.timeAvailable >= this.fixedDeltaTime && count < this.maxStepsPerFrame) {
        this.timeAvailable -= this.fixedDeltaTime;
        this.stepping = true;
        this.world.Step(this.fixedDeltaTime, this.maxVelocityIterations, this.maxPositionIterations);
        count++;
        this.stepCount++;
        this.stepping = false;
        this.internalDestroyMarkedBodies();
        if (this.stepCallback) {
            this.stepCallback.call();
        }
        this.internalDestroyMarkedBodies();
    }
};
tbPhysics2.prototype.wakeUp = function (body) {
    "use strict";
    body.SetAwake(true);
};
tbPhysics2.prototype.setAwake = function (body, value) {
    "use strict";
    body.SetAwake(value);
};
//Vertices can be either an array of b2Vec2 or tbVector
tbPhysics2.prototype.createPolygonShape = function (vertices) {
    var shape = new Box2D.b2PolygonShape();
    var buffer = Box2D.allocate(vertices.length * 8, 'float', Box2D.ALLOC_STACK);
    var offset = 0;
    for (var i = 0; i < vertices.length; i++) {
        var x = typeof vertices[i].get_x === "function" ? vertices[i].get_x() : vertices[i].x;
        var y = typeof vertices[i].get_y === "function" ? vertices[i].get_y() : vertices[i].y;
        Box2D.setValue(buffer + (offset), x * this.scale, 'float'); // x
        Box2D.setValue(buffer + (offset + 4), y * this.scale, 'float'); // y
        offset += 8;
    }
    var ptr_wrapped = Box2D.wrapPointer(buffer, Box2D.b2Vec2);
    shape.Set(ptr_wrapped, vertices.length);
    return shape;
};
// Vertices can be either an array of b2Vec2 or tbVector
tbPhysics2.prototype.createChainShape = function (vertices, closedLoop) {
    var shape = new Box2D.b2ChainShape();
    var buffer = Box2D.allocate(vertices.length * 8, 'float', Box2D.ALLOC_STACK);
    var offset = 0;
    for (var i = 0; i < vertices.length; i++) {
        var x = typeof vertices[i].get_x === "function" ? vertices[i].get_x() : vertices[i].x;
        var y = typeof vertices[i].get_y === "function" ? vertices[i].get_y() : vertices[i].y;
        Box2D.setValue(buffer + (offset), x * this.scale, 'float'); // x
        Box2D.setValue(buffer + (offset + 4), y * this.scale, 'float'); // y
        offset += 8;
    }
    var ptr_wrapped = Box2D.wrapPointer(buffer, Box2D.b2Vec2);
    if (closedLoop)
        shape.CreateLoop(ptr_wrapped, vertices.length);
    else
        shape.CreateChain(ptr_wrapped, vertices.length);
    return shape;
};
tbPhysics2.prototype.setRadius = function (body, radius) {
    "use strict";
    body.GetFixtureList().GetShape().set_m_radius(radius * this.scale);
    this.wakeUp(body);
};
// Takes a b2Vec and returns a tbVector with the correct scaling applied
tbPhysics2.prototype.vectorFromBox2D = function (b2Vec) {
    return new tbVector(b2Vec.get_x(), b2Vec.get_y()).scale(1 / this.scale);
};
tbPhysics2.prototype.getHash = function () {
    var hash = 0;
    var body = this.world.GetBodyList();
    while (Box2D.getPointer(body)) { // <-- will equal 0 for a Box2D.NULL object
        var data = new tbVector();
        this.getBodyData(body, data);
        var h = 0;
        h += data.x;
        h += data.y;
        h += data.angle;
        h += (data.radius || 0);
        h += data.velocity.x;
        h += data.velocity.y;
        h += data.angular_velocity;
        hash = ((hash + h) % 123456789);
        body = body.GetNext();
    }
    return hash;
};
tbPhysics2.prototype.destroyBody = function (body) {
    if (this.stepping) {
        this.bodiesMarkedForDeletion.push(body);
    }
    else {
        this.internalDestroyBody(body);
    }
};
tbPhysics2.prototype.internalDestroyMarkedBodies = function () {
    for (var i = 0; i < this.bodiesMarkedForDeletion.length; i++) {
        this.internalDestroyBody(this.bodiesMarkedForDeletion[i]);
    }
    this.bodiesMarkedForDeletion = [];
};
tbPhysics2.prototype.internalDestroyBody = function (body) {
    var count = 0;
    var list = body.GetJointList();
    while (Box2D.getPointer(list)) { // <-- will equal 0 for a Box2D.NULL object
        var joint = list.get_joint();
        this.world.DestroyJoint(joint);
        list = list.get_next();
    }
    this.world.DestroyBody(body);
};
//returns the intersection point closest to "start" and between "start" and "end"
tbPhysics2.prototype.rayCast = function (start, end) {
    var self = this;
    var p0 = this.temp.vec1;
    var p1 = this.temp.vec2;
    var result = { x: 0, y: 0, hit: false };
    var minFraction = Number.MAX_VALUE;
    var callback = new Box2D.JSRayCastCallback();
    callback["ReportFixture"] = function (pFixture, pPoint, pNormal, fraction) {
        /** @type Module.b2Fixture */
        var f = Box2D.wrapPointer(pFixture, Box2D.b2Fixture);
        /** @type Module.b2Body */
        var b = f.GetBody();
        if (fraction >= 0 && fraction <= 1) {
            if (fraction < minFraction) {
                minFraction = fraction;
                result.hit = true;
                result.x = Box2D.wrapPointer(pPoint, Box2D.b2Vec2).get_x() / self.scale;
                result.y = Box2D.wrapPointer(pPoint, Box2D.b2Vec2).get_y() / self.scale;
                result.body = f.GetBody();
            }
            return 1;
        }
        return -1;
    };
    p0.Set(start.x * this.scale, start.y * this.scale);
    p1.Set(end.x * this.scale, end.y * this.scale);
    this.world.RayCast(callback, p0, p1);
    return result;
};
tbPhysics2.prototype.getTrajectory = function (points, startingPosition, startingVelocity, step, stopOnIntersection, radius, minPoints) {
    var p = startingPosition.scale(this.scale);
    var v = startingVelocity.scale(this.scale);
    var rayRadius = radius || 0;
    var minDistance = minPoints || 0;
    var isIntersecting = false;
    var p0 = this.temp.vec1;
    var p1 = this.temp.vec2;
    var callback = new Box2D.JSRayCastCallback();
    callback["ReportFixture"] = function (pFixture, pPoint, pNormal, fraction) {
        /** @type Module.b2Fixture */
        var f = Box2D.wrapPointer(pFixture, Box2D.b2Fixture);
        /** @type Module.b2Body */
        var b = f.GetBody();
        isIntersecting = fraction <= 1;
        if (isIntersecting) {
            return 0; //stop the raytrace
        }
        else {
            return -1; //ignore this intersection
        }
    };
    var length = 0;
    for (var i = 0; i < points.length; i++) {
        this._getTrajectoryPoint(points[i], p, v, i * step);
        length++;
        if (stopOnIntersection && i > minDistance) {
            // use rayRadius to calculate this twice
            p0.Set(points[i - 1].x, points[i - 1].y - rayRadius);
            p1.Set(points[i].x, points[i].y - rayRadius);
            isIntersecting = false;
            var r = this.world.RayCast(callback, p1, p0);
            if (!isIntersecting && rayRadius) {
                p0.Set(points[i - 1].x, points[i - 1].y + rayRadius);
                p1.Set(points[i].x, points[i].y + rayRadius);
                isIntersecting = false;
                r = this.world.RayCast(callback, p1, p0);
            }
            if (isIntersecting) {
                break;
            }
        }
    }
    for (var i = 0; i < length; i++) {
        points[i].scaleDirect(1 / this.scale);
    }
    return length;
};
tbPhysics2.prototype._getTrajectoryPoint = function (retPoint, startingPosition, startingVelocity, n) {
    var t = this.fixedDeltaTime;
    var stepVelocity = startingVelocity.scale(t);
    var stepGravity = this.gravityVector.scale(t * t);
    stepVelocity.scaleDirect(n);
    stepGravity.scaleDirect(0.5 * (n * n + n));
    retPoint.x = startingPosition.x + stepVelocity.x + stepGravity.x;
    retPoint.y = startingPosition.y + stepVelocity.y + stepGravity.y;
};
/**
 * This function calculates the launch angles needed to launch an object
 * from startingPosition with speed projectileSpeed so that it reaches the targetPosition
 *
 * Reference: https://answers.unity.com/questions/49195/trajectory-of-a-projectile-formula-does-anyone-kno.html
 *
 * Returns an array containing the possible angles
 * If it is not possible and empty array is returned.
 */
tbPhysics2.prototype.getPossibleLaunchAngles = function (targetPosition, startingPosition, projectileSpeed, gravity) {
    var targetPositionCopy = targetPosition.clone();
    var startingPositionCopy = startingPosition.clone();
    var y = startingPositionCopy.y - targetPositionCopy.y;
    targetPositionCopy.y = startingPositionCopy.y = 0;
    var x = targetPositionCopy.subtract(startingPositionCopy).magnitude();
    var v = projectileSpeed;
    var g = gravity;
    var sqrt = (v * v * v * v) - (g * (g * (x * x) + 2 * y * (v * v)));
    // Not enough range
    if (sqrt < 0) {
        return [];
    }
    sqrt = Math.sqrt(sqrt);
    var possibleAngles = [];
    // low shot
    possibleAngles.push(Math.atan(((v * v) - sqrt) / (g * x)));
    // high shot
    possibleAngles.push(Math.atan(((v * v) + sqrt) / (g * x)));
    return possibleAngles;
};
tbPhysics2.prototype.isTrajectoryValid = function (points, startingPosition, startingVelocity, step, targetPosition, radius, filterFunction) {
    var p = startingPosition.scale(this.scale);
    var v = startingVelocity.scale(this.scale);
    radius = radius ? radius : 1;
    var rayRadius = radius * this.scale;
    var scaledTargetPosition = targetPosition.scale(this.scale);
    var isValid = true;
    var isIntersecting = false;
    var p0 = this.temp.vec1;
    var p1 = this.temp.vec2;
    var callback = new Box2D.JSRayCastCallback();
    callback["ReportFixture"] = function (pFixture, pPoint, pNormal, fraction) {
        /** @type Module.b2Fixture */
        var f = Box2D.wrapPointer(pFixture, Box2D.b2Fixture);
        /** @type Module.b2Body */
        var b = f.GetBody();
        isIntersecting = fraction <= 1;
        if (isIntersecting) {
            if (filterFunction) {
                isValid = filterFunction(b);
                if (isValid !== undefined) {
                    return 0;
                }
            }
            isIntersecting = false;
            return -1;
        }
        else {
            return -1; //ignore this intersection
        }
    };
    for (var i = 0; i < points.length; i++) {
        var pointStep = i * step;
        this._getTrajectoryPoint(points[i], p, v, i * step);
        if (i > 0) {
            // use rayRadius to calculate this twice
            p0.Set(points[i - 1].x, points[i - 1].y - rayRadius);
            p1.Set(points[i].x, points[i].y - rayRadius);
            isIntersecting = false;
            var r = this.world.RayCast(callback, p1, p0);
            if (!isIntersecting) {
                p0.Set(points[i - 1].x, points[i - 1].y + rayRadius);
                p1.Set(points[i].x, points[i].y + rayRadius);
                isIntersecting = false;
                r = this.world.RayCast(callback, p1, p0);
            }
            if (isIntersecting) {
                return isValid;
            }
        }
    }
};
tbPhysics2.prototype.getTrajectoryResistanceDistance = function (points, startingPosition, startingVelocity, step, targetPosition, radius) {
    var p = startingPosition.scale(this.scale);
    var v = startingVelocity.scale(this.scale);
    var rayRadius = radius * this.scale;
    var scaledTargetPosition = targetPosition.scale(this.scale);
    var hitFraction = 0;
    var hitObject;
    var isIntersecting = false;
    var p0 = this.temp.vec1;
    var p1 = this.temp.vec2;
    var callback = new Box2D.JSRayCastCallback();
    callback["ReportFixture"] = function (pFixture, pPoint, pNormal, fraction) {
        /** @type Module.b2Fixture */
        var f = Box2D.wrapPointer(pFixture, Box2D.b2Fixture);
        /** @type Module.b2Body */
        var b = f.GetBody();
        isIntersecting = fraction <= 1;
        if (isIntersecting) {
            hitFraction = fraction;
            hitObject = b.physicsObj;
            return 0; //stop the raytrace
        }
        else {
            return -1; //ignore this intersection
        }
    };
    var length = 0;
    var resistanceDistance = 0;
    for (var i = 0; i < points.length; i++) {
        var pointStep = i * step;
        this._getTrajectoryPoint(points[i], p, v, i * step);
        length++;
        if (i > 0) {
            // use rayRadius to calculate this twice
            p0.Set(points[i - 1].x, points[i - 1].y - rayRadius);
            p1.Set(points[i].x, points[i].y - rayRadius);
            isIntersecting = false;
            var r = this.world.RayCast(callback, p1, p0);
            if (!isIntersecting) {
                p0.Set(points[i - 1].x, points[i - 1].y + rayRadius);
                p1.Set(points[i].x, points[i].y + rayRadius);
                isIntersecting = false;
                r = this.world.RayCast(callback, p1, p0);
            }
            if (isIntersecting) {
                var point0 = new tbVector(points[i - 1].x, points[i - 1].y);
                var point1 = new tbVector(points[i].x, points[i].y);
                var distanceBetweenPoints = point1.subtract(point0);
                var distanceToHitpoint = distanceBetweenPoints.scale(hitFraction);
                var hitPoint = point0.add(distanceToHitpoint);
                var hitStepForPoint = Math.round(pointStep - step + step * hitFraction);
                resistanceDistance = scaledTargetPosition.distance(hitPoint);
                var returnObject = {
                    distance: resistanceDistance,
                    hitStep: hitStepForPoint,
                    hitObject: hitObject
                };
                return returnObject;
            }
        }
    }
    for (var i = 0; i < length; i++) {
        points[i].scaleDirect(1 / this.scale);
    }
    return length;
};
